import { render } from "./Menu.vue?vue&type=template&id=33d32ce8&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=33d32ce8&lang=css&scoped=true"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d32ce8"]])

export default __exports__